import React from "react";

import { Grid, MenuItem, SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { Input, Select } from "../../../../../../../components/Form";
import { Color } from "../../../../../../../components/Form/Button";
import ActionButtons from "../../../../../../../components/Generic/ActionButtons";
import LoadingModal from "../../../../../../../components/LoadingModal";
import useYupValidation from "../../../../../../../hooks/useYupValidation";
import { Account } from "../../../../../../../models/account";
import { Error } from "../../../../../../../models/error";
import { Status } from "../../../../../../../util/enums";
import { ButtonsWrapper, TabTitle } from "./styles";

interface DetailsProps {
  account?: Account;
  errors?: yup.ValidationError[];
  handleUpdateAccount?: (attribute: string, value: any) => void;
  loadingAccount?: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  responseError?: Error;
}

const Details = ({
  account,
  errors,
  handleUpdateAccount,
  loadingAccount,
  onCancel,
  onSave,
  responseError,
}: DetailsProps) => {
  const { t: translate } = useTranslation();

  const { fieldHasError, getErrorByField } = useYupValidation(errors || []);

  return (
    <Grid container>
      <Grid container item xs={12} sm={9}>
        <Grid container>
          <TabTitle id="tabTitle">{translate("accountDetails")}</TabTitle>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Input
              label={translate("name")}
              placeholder={translate("typeHere")}
              required
              name="accountName"
              error={fieldHasError("name")}
              errorMessage={getErrorByField("name")}
              errorResponse={responseError}
              value={account?.name}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleUpdateAccount?.("name", event.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Select
              label={translate("status")}
              required
              name="accountStatus"
              error={fieldHasError("status")}
              errorMessage={getErrorByField("status")}
              errorResponse={responseError}
              value={account?.status}
              onChange={(event: SelectChangeEvent<any>) =>
                handleUpdateAccount?.("status", event.target.value)
              }
            >
              <MenuItem value={Status.ACTIVE}>{translate("active")}</MenuItem>
              <MenuItem value={Status.INACTIVE}>{translate("inactive")}</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </Grid>

      <ButtonsWrapper container>
        <ActionButtons
          onCancel={onCancel}
          onSave={onSave}
          customColorCancel={Color.TEXT_INFO}
          textSave={account && account.id ? translate("save") : translate("create")}
          cancelDisabled={loadingAccount}
          saveDisabled={loadingAccount}
          dataCySave="saveButton"
          dataCyCancel="cancelButton"
        />
      </ButtonsWrapper>
      <LoadingModal showing={loadingAccount} />
    </Grid>
  );
};

export default Details;
